module.exports = __webpack_public_path__ + "img/allListbanner.9a9cda4a.png";